import { Menu } from 'antd';
import { Header } from 'antd/lib/layout/layout';
import { useUser } from 'hooks';
import { useOrgId } from 'hooks/useOrg';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { isOrgAdmin } from 'utils/rbac';
import './Platform.less';

const menuItems = [
  'user-account',
  'org',
  'network',
  'sku',
  'eqpt',
  'material',
  'svc',
  'parcel',
  'shipping',
  'markup',
  'tf',
  'resources',
  'CSR',
  'SLA',
];

const orgAdminMenuItems = [
  'user-account',
  'org',
  'network',
  'sku',
  'eqpt',
  'material',
  'svc',
  'parcel',
  'shipping',
  'markup',
  'tf',
  'resources',
  'CSR',
  'SLA',
];

const i18nKeyPrefix = 'platform.platformMenu.';

const PlatformMenu = () => {
  const { t } = useTranslation();
  const match = useRouteMatch();
  const location = useLocation();
  const user = useUser();
  const orgId = useOrgId();
  const history = useHistory();

  const menuList = useMemo(() => {
    const menus = isOrgAdmin(user) ? orgAdminMenuItems : menuItems;
    if (orgId === 1 && !menus.includes('resellerCertificate')) {
      menus.push('resellerCertificate');
    }
    return menus;
  }, [user, orgId]);

  useEffect(() => {
    if (
      orgId !== 1 &&
      history.location.pathname.includes('/resellerCertificate')
    ) {
      history.replace(`${match.path}/user-account`);
    }
  }, [orgId, history, match.path]);

  return (
    <Header className="platform-menu">
      <Menu
        selectedKeys={[
          menuList.find((v) =>
            location.pathname.startsWith(`${match.path}/${v}`)
          ) || '',
        ]}
        mode="horizontal"
        theme="light"
      >
        {menuList.map((item) => (
          <Menu.Item key={item}>
            <Link to={`${match.path}/${item}`}>
              {t((i18nKeyPrefix + item) as any)}
            </Link>
          </Menu.Item>
        ))}
      </Menu>
    </Header>
  );
};
export default PlatformMenu;
